import { Injectable } from '@angular/core';
import { LicenseTypeKind } from '../../model/const/enum';
import { LicenseService } from '../data/license.service';
import { UserAccountService } from '../user-account.service';
import { LicenseGuard } from './license-guard.service';
import { NavigationService } from '../../../core/service/navigation.service';

@Injectable({
  providedIn: 'root',
})
export class LicenseHomepalDashboardGuard extends LicenseGuard {
  constructor(licenseService: LicenseService, userAccountService: UserAccountService, navigation: NavigationService) {
    super(licenseService, userAccountService, navigation);
  }

  protected override get licenseTypeKind(): LicenseTypeKind {
    return LicenseTypeKind.HomepalDashboards;
  }
}
